export default "__VITE_ASSET__DHQ1eM0i__"